module.exports = __webpack_public_path__ + "static/media/credit-wallet-arrow.204cb609.svg";